import { InfoCircleFilled } from "@ant-design/icons";
import { ReactElement } from "react";
import { ISupportCalloutProps } from "../../interfaces/props/ISupportCalloutProps";

import classes from "./SupportCallout.module.css";

/**
 * Компонент выводит подсказку о необходимости обратиться в поддержку для изменения данных или реквизитов в профиле.
 *
 * @param {ISupportCalloutProps} props - Свойства компонента.
 * @prop {string} [className] - CSS-класс, добавляемый к корневому элементу компонента.
 */
export function SupportCallout(props: ISupportCalloutProps): ReactElement {
  const { className = "" } = props;
  const messageText =
    "Для отзыва согласия, изменения данных или реквизитов, удаления аккаунта, а также для запроса на доступ к своим персональным данным Вам необходимо обратиться в поддержку по адресу электронной почты";
  const messageLink = (
    <a href={`mailto: ${process.env.REACT_APP_IT_ONLINE_MAIL}`}>
      {process.env.REACT_APP_IT_ONLINE_MAIL}
    </a>
  );

  return (
    <div className={`${className} ${classes.supportCallout}`}>
      <InfoCircleFilled className={classes.supportCallout__icon} />
      <span className={classes.supportCallout__text}>
        {messageText} по адресу {messageLink}.
      </span>
    </div>
  );
}
